function toCamelCase(str) {
  return str.replace(/(_\w)/g, function(match) {
    return match[1].toUpperCase();
  });
}

/**
 * camelCase 도 가능
 */
export const INPUT_MAXLENGTH = Object.freeze(
  Object.entries({
    ability_intro: 5000,
    awards_date: 8,
    awards_name: 100,
    awards_org: 50,
    base_addr: 100,
    base_addr_detail: 100,
    base_addr_eng: 100,
    base_apartment: 1,
    base_bcode: 20,
    base_birthday: 8,
    base_bname: 50,
    base_bname1: 50,
    base_bname1_eng: 50,
    base_bname2: 50,
    base_bname2_eng: 50,
    base_bname_eng: 50,
    base_building_code: 50,
    base_building_name: 100,
    base_gender: 1,
    base_hname: 50,
    base_jibun_addr: 100,
    base_jibun_addr_eng: 100,
    base_name_ch: 20,
    base_name_en: 50,
    base_nationality: 100,
    base_roadname: 50,
    base_roadname_code: 20,
    base_roadname_eng: 50,
    base_road_addr: 100,
    base_road_addr_eng: 100,
    base_sido: 50,
    base_sido_eng: 50,
    base_sigungu: 50,
    base_sigungu_code: 20,
    base_sigungu_eng: 50,
    base_zonecode: 10,
    career_company: 200,
    career_edate: 8,
    career_emp_type: 20,
    career_file_id: 50,
    career_group: 200,
    career_in_yn: 1,
    career_num_emps: 10,
    career_org: 50,
    career_position: 20,
    career_reason: 500,
    career_revenue: 50,
    career_salary: 50,
    career_sdate: 8,
    career_task: 200,
    col: 45,
    col_nm: 100,
    community_edate: 8,
    community_name: 100,
    community_nation: 50,
    community_org: 100,
    community_sdate: 8,
    company_cd: 45,
    custom1: 50,
    custom2: 50,
    custom3: 50,
    custom4: 50,
    custom5: 50,
    custom6: 50,
    custom7: 50,
    custom8: 50,
    custom9: 50,
    cv_column: 20,
    direct_input: 1,
    education_edate: 8,
    education_name: 50,
    education_org: 50,
    education_sdate: 8,
    etc_current_salary: 30,
    etc_nationality: 50,
    etc_path: 20,
    etc_phone_sub: 20,
    etc_position: 30,
    etc_recommender: 50,
    etc_recommender_org: 30,
    etc_recommender_relation: 30,
    etc_recommender_tel: 20,
    etc_salary: 20,
    etc_salary_rule_yn: 1,
    etc_salary_unit: 10,
    impairment_class: 20,
    impairment_type: 20,
    impairment_yn: 1,
    language_date: 8,
    language_direct_yn: 1,
    language_grade: 20,
    language_name: 100,
    language_number: 30,
    language_org: 50,
    language_type: 20,
    license_date: 8,
    license_direct_yn: 1,
    license_name: 100,
    license_number: 50,
    license_org: 50,
    military_class: 20,
    military_edate: 8,
    military_kind: 20,
    military_level: 20,
    military_number: 20,
    military_reason: 50,
    military_sdate: 8,
    military_type: 20,
    military_yn: 20,
    more_questions: 5000,
    nationality: 100,
    overseas_country: 50,
    overseas_edate: 8,
    overseas_file_id: 50,
    overseas_sdate: 8,
    project_buyer: 100,
    project_company: 100,
    project_contribution: 20,
    project_edate: 8,
    project_in_yn: 1,
    project_name: 1000,
    project_sdate: 8,
    school_adres: 100,
    school_campus: 200,
    school_day_night: 20,
    school_direct_yn: 1,
    school_edate: 8,
    school_est_type: 50,
    school_etc: 100,
    school_etype: 20,
    school_file_id: 50,
    school_gubun: 50,
    school_in_yn: 1,
    school_link: 100,
    school_major: 100,
    school_major_direct_yn: 1,
    school_major_etc: 100,
    school_major_l_class: 50,
    school_major_seq: 50,
    school_major_sub: 100,
    school_major_sub2: 100,
    school_major_sub2_direct_yn: 1,
    school_major_sub2_etc: 100,
    school_major_sub2_l_class: 50,
    school_major_sub2_seq: 50,
    school_major_sub2_type: 20,
    school_major_sub3: 100,
    school_major_sub3_direct_yn: 1,
    school_major_sub3_etc: 100,
    school_major_sub3_l_class: 50,
    school_major_sub3_seq: 50,
    school_major_sub3_type: 20,
    school_major_sub_direct_yn: 1,
    school_major_sub_etc: 100,
    school_major_sub_l_class: 50,
    school_major_sub_seq: 50,
    school_major_sub_type: 20,
    school_name: 200,
    school_region: 50,
    school_sdate: 8,
    school_stype: 20,
    school_type: 50,
    school_url: 100,
    section: 45,
    section_nm: 100,
    self_intro: 5000,
    url_info: 1000,
    uses_gubun: 20,
    uses_level: 10,
    uses_name: 100,
    uses_term: 20,
    veterans_grade: 20,
    veterans_number: 20,
    veterans_relation: 50,
    veterans_type: 20,
    veterans_yn: 1,
    vulnerable_grade: 20,
    vulnerable_type: 20,
    vulnerable_yn: 1,
  }).reduce(
    (a, [key, value]) =>
      Object.assign(a, {
        [key]: value,
        [toCamelCase(key)]: value,
      }),
    {},
  ),
);
